@if(isShowScrollBtns()){

<div class="tw-flex tw-justify-between tw-mb-2 tw-w-full">
  <!-- دکمه اسکرول به راست -->
  <div
    class="ltr:tw-order-2 tw-mx-2 tw-bg-gray-500 dark:tw-bg-gray-600 tw-z-40 tw-opacity-70 hover:tw-opacity-80 tw-rounded-full tw-shadow-md tw-h-8 tw-w-8 tw-flex-center tw-cursor-pointer"
    [style.top]="rowHeight - 10 + 'px'"
    (mousedown)="startScrollRight()"
    (mouseup)="stopScroll()"
    (mouseleave)="stopScroll()"
    (click)="scrollRight()"
  >
    <i
      class="mdi mdi-26px !tw-text-gray-200"
      [ngClass]="appState.isLtr() ? 'mdi-chevron-left' : 'mdi-chevron-right'"
    ></i>
  </div>

  <!-- دکمه اسکرول به چپ -->
  <div
    (mousedown)="startScrollLeft()"
    (mouseup)="stopScroll()"
    (mouseleave)="stopScroll()"
    (click)="scrollLeft()"
    [style.top]="rowHeight - 10 + 'px'"
    class="tw-mx-2 tw-bg-gray-500 dark:tw-bg-gray-600 tw-z-40 tw-opacity-70 hover:tw-opacity-80 tw-rounded-full tw-shadow-md tw-h-8 tw-w-8 tw-flex-center tw-cursor-pointer"
  >
    <i
      class="mdi mdi-26px !tw-text-gray-200"
      [ngClass]="appState.isLtr() ? 'mdi-chevron-right' : 'mdi-chevron-left'"
    ></i>
  </div>
</div>
}

<div #editorContainer #scroller></div>
